import { ManageUserFormValue } from './manage-user.interfaces';

export function createManageUserFormValue(): ManageUserFormValue {
  return {
    email: '',
    first_name: '',
    last_name: '',
    mobile_no: '',
    role_id: null,
    substation_id: null,
    generator_id: null,
  };
}
